<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 13.5C9 13.7761 9.22386 14 9.5 14H15.5C15.7761 14 16 13.7761 16 13.5V12.5C16 12.2239 15.7761 12 15.5 12H9.5C9.22386 12 9 12.2239 9 12.5V13.5Z"
      fill="#738288" />
    <path
      d="M9 17.5C9 17.7761 9.22386 18 9.5 18H17.5C17.7761 18 18 17.7761 18 17.5V16.5C18 16.2239 17.7761 16 17.5 16H9.5C9.22386 16 9 16.2239 9 16.5V17.5Z"
      fill="#738288" />
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M5 4C5 2.34315 6.34315 1 8 1H14.1716C14.9672 1 15.7303 1.31607 16.2929 1.87868L21.1213 6.70711C21.6839 7.26972 22 8.03278 22 8.82843V20C22 21.6569 20.6569 23 19 23H8C6.34315 23 5 21.6569 5 20V4ZM8 3C7.44772 3 7 3.44772 7 4V20C7 20.5523 7.44772 21 8 21H19C19.5523 21 20 20.5523 20 20V9H16C14.8954 9 14 8.10457 14 7V3H8ZM16 4.41421L18.5858 7H16V4.41421Z"
          fill="#738288" />
    <path
      d="M2 5.71429C2 4.76751 2.76751 4 3.71429 4C3.87208 4 4 4.12792 4 4.28571V19.7143C4 19.8721 3.87208 20 3.71429 20C2.76751 20 2 19.2325 2 18.2857V5.71429Z"
      fill="#738288" />
  </svg>
</template>

<script>
export default {}
</script>

<style scoped>

</style>
